var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoteSingleOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 25.875,
    viewBox: "0 0 24 25.875",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.757 4.895-3.561-3.282C17.421.898 15.889.314 14.792.314H2.827C1.73.314.833 1.141.833 2.152v19.849c0 1.011.898 1.838 1.994 1.838h18.346c1.097 0 1.994-.827 1.994-1.838V8.031c0-1.01-.635-2.422-1.41-3.136m-1.128 1.039q.117.108.231.26h-4.074V2.439q.163.105.282.213zm.942 16.065c0 .199-.183.367-.399.367H2.827c-.217 0-.399-.169-.399-.367V2.151c0-.199.183-.367.399-.367h11.965q.183 0 .399.039v5.842h6.338q.041.2.042.367z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.046 12.074-6.306 5.967H9.404v-2.21l6.306-5.967zm.788-.746-2.335-2.21.818-.774a.73.73 0 0 1 .991 0l1.345 1.273a.64.64 0 0 1 0 .938zm-1.956 3.89v4.591H7.536v-8.841h5.138L14.543 9.2H7.069c-.771 0-1.402.597-1.402 1.326v9.725c0 .73.631 1.326 1.402 1.326h10.277c.771 0 1.402-.597 1.402-1.326V13.63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.834 24.304H8v1.391H.834zM16.001 24.304h7.166v1.391h-7.166zM11.045 24.304h1.911v1.391h-1.911z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteSingleOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note-single-on.svg";